import React from 'react';
export function TraditionalDealSourceSection() {
  return <section className="mb-16 animate-on-scroll bg-[#f8f9fa] p-8 md:p-12 rounded-lg" data-id="element-266">
      <h2 className="text-[24px] md:text-[28px] font-bold mb-8 text-black text-center" data-id="element-267">
        The Problem With Traditional Deal Sourcing
      </h2>
      <div className="bg-white border-l-4 border-[#00be60] p-6 rounded-r-lg shadow-sm" data-id="element-268">
        <ul className="space-y-4" data-id="element-269">
          <li className="text-[15px] md:text-[16px] text-black" data-id="element-270">
            <span className="font-bold" data-id="element-271">Broker auction premiums:</span> Paying
            20-30% above fair value due to competitive bidding
          </li>
          <li className="text-[15px] md:text-[16px] text-black" data-id="element-272">
            <span className="font-bold" data-id="element-273">BD team inefficiency:</span> $500K+
            annual cost per rep generating 50-100 qualified conversations
          </li>
          <li className="text-[15px] md:text-[16px] text-black" data-id="element-274">
            <span className="font-bold" data-id="element-275">Process drag:</span> Weeks analyzing
            broker deals only to lose in final rounds to strategic buyers
          </li>
          <li className="text-[15px] md:text-[16px] text-black" data-id="element-276">
            <span className="font-bold" data-id="element-277">Buy box drift:</span> Chasing suboptimal
            deals due to inconsistent pipeline flow
          </li>
        </ul>
      </div>
    </section>;
}